export default {"src":"/_next/static/media/icon-heaps.74c33f22.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};